import moment from "moment";
import {
  BLOCK,
  DATE_FORMAT_FULL,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  filtersJson,
  statusTextReverse,
  STATUS_FLEXIBLE,
} from "../commons/commonConstant";
import { v4 as uuid } from "uuid";
export const formatDate = (date) => {
  if (date) return moment(date).format("DD/MM/YYYY");
  else return "";
};
export const formatTime = (date) => {
  if (date) return moment(date).format("HH:mm");
  return "";
};
export const convertObjectToParams = (filters, key) => {
  let params = "";
  if (filters)
    Object.keys(filters).map((it) => {
      let val = filters[it];
      if ((it === "fromDate" || it === "toDate") && filters[it]) {
        if (key === "checkInOut-TMS-report") {
          val = moment(filters[it]).format("YYYYMMDD");
        } else if (key === "special_explanation") {
          val = moment(filters[it]).format(DATE_FORMAT_V2);
        } else {
          val = moment(filters[it]).format("DD-MM-YYYY");
        }
      }
      if (Array.isArray(val)) {
        if (val.length > 0) {
          if (params.indexOf("?") > -1) {
            params += `&${it}=${val}`;
          } else {
            params += `?${it}=${val}`;
          }
        }
      } else if (val) {
        if (params.indexOf("?") > -1) {
          params += `&${it}=${val}`;
        } else {
          params += `?${it}=${val}`;
        }
      }
      return params;
    });
  return params;
};

export const initFilters = (filters, currentScreen, userInfo, currentTab) => {
  if (currentScreen !== "timesheet" && currentScreen !== "payroll_list" && currentScreen !== "payslip") {
    if (moment().date() >= 26) {
      if (
        moment()
          .add(1, "month")
          .endOf("month")
          .date() === 31
      ) {
        filters.fromDate = moment()
          .startOf("month")
          .add(25, "days");
        filters.toDate = moment()
          .add(1, "month")
          .endOf("month")
          .subtract(6, "days");
      } else if (
        moment()
          .add(1, "month")
          .endOf("month")
          .date() === 30
      ) {
        filters.fromDate = moment()
          .startOf("month")
          .add(25, "days");
        filters.toDate = moment()
          .add(1, "month")
          .endOf("month")
          .subtract(5, "days");
      } else if (
        moment()
          .add(1, "month")
          .endOf("month")
          .date() === 28
      ) {
        filters.fromDate = moment()
          .startOf("month")
          .add(25, "days");
        filters.toDate = moment()
          .add(1, "month")
          .endOf("month")
          .subtract(3, "days");
      } else if (
        moment()
          .add(1, "month")
          .endOf("month")
          .date() === 29
      ) {
        filters.fromDate = moment()
          .startOf("month")
          .add(25, "days");
        filters.toDate = moment()
          .add(1, "month")
          .endOf("month")
          .subtract(4, "days");
      }
    } else {
      if (
        moment()
          .subtract(1, "month")
          .endOf("month")
          .date() === 31
      ) {
        filters.fromDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .subtract(5, "days");
        filters.toDate = moment()
          .startOf("month")
          .add(24, "days");
      } else if (
        moment()
          .subtract(1, "month")
          .endOf("month")
          .date() === 30
      ) {
        filters.fromDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .subtract(4, "days");
        filters.toDate = moment()
          .startOf("month")
          .add(24, "days");
      } else if (
        moment()
          .subtract(1, "month")
          .endOf("month")
          .date() === 29
      ) {
        filters.fromDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .subtract(3, "days");
        filters.toDate = moment()
          .startOf("month")
          .add(24, "days");
      } else if (
        moment()
          .subtract(1, "month")
          .endOf("month")
          .date() === 28
      ) {
        filters.fromDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .subtract(2, "days");
        filters.toDate = moment()
          .startOf("month")
          .add(24, "days");
      }
    }
  }
  let filtersJsonControls;
  if (currentScreen !== "delegation_management" && currentScreen !== "payroll_list") {
    filtersJsonControls = filtersJson[currentScreen].controls;
    filtersJsonControls.forEach((element) => {
      if (element.name === "status") {
        if (
          (currentScreen === "overtime_management" || currentScreen === "overtime_management_staff") &&
          currentTab === "flexibleTab"
        ) {
          filters.status = [2, 3, 4];
        } else {
          filters.status = statusTextReverse.PENDING;
        }
      }
      if (element.name === "department") {
        filters.department = userInfo.userDepartment;
      }
    });
  } else if (currentScreen === "delegation_management") {
    filtersJsonControls = filtersJson[currentScreen].delegation_list.controls;
    filtersJsonControls.forEach((element) => {
      if (element.name === "department") {
        filters.department = userInfo.userDepartment;
      }
    });
  } else if (currentScreen === "payroll_list") {
    Object.keys(filtersJson["payroll_list"]).forEach((key) => {
      let filterControls = filtersJson[currentScreen];
      filtersJsonControls = filterControls[key].controls;
      filtersJsonControls.forEach((element) => {
        if (element.name === "department") {
          filters.department = userInfo.userDepartment;
        }
      });
    });
  }
  return filters;
};

export const getStatusTimeSheet = (status) => {
  switch (status) {
    case 0:
      return { text: "Draft", color: "" };
    case 2:
      return { text: "Pending update", color: "blue" };
    case 3:
      return { text: "Pending approval", color: "orange" };
    case 4:
      return { text: "Approved", color: "green" };
    default:
      return { text: "", color: "white" };
  }
};

export const getContractTypePayroll = (dataIndex) => {
  let contracType = "";
  if (dataIndex === "probationary_overtime" || dataIndex === "probationary_overtime_excess") {
    contracType = "probationary";
  }
  if (dataIndex === "official_overtime" || dataIndex === "official_overtime_excess") {
    contracType = "official";
  }
  return contracType;
};

export const getNameModifedFields = (arrayDetail, arrayModified) => {
  for (const element of arrayDetail) {
    if (element && element.prefix) {
      let key = element.prefix + "." + element.key;
      arrayModified.push(key);
    }
  }
  return arrayModified;
};

export const getContractType = (value) => {
  switch (value) {
    case "1236":
      return { type: "1236", name: "Fixed-term Contract" };
    case "ANNEX":
      return { type: "ANNEX", name: "Annex Contract" };
    case "C":
      return { type: "C", name: "Contracting contract" };
    case "COLLA":
      return { type: "COLLA", name: "Collaborator" };
    case "P":
      return { type: "P", name: "Probationary contracts" };
    case "SEA":
      return { type: "SEA", name: "Seasonal contract" };
    case "SEV":
      return { type: "SEV", name: "Service contract" };
    case "T":
      return { type: "T", name: "Training contract" };
    case "UNLIMTED":
      return { type: "UNLIMTED", name: "Permanent Contract" };
    default:
      return { text: "", name: "" };
  }
};

export const downloadFile = (data, fileName) => {
  var fileURL = URL.createObjectURL(
    new Blob([data], {
      type: "application/vnd.ms-excel",
    })
  );
  var fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", fileName);
  document.body.appendChild(fileLink);
  fileLink.click();
};

export const convertAvatarName = (fullName) => {
  if (fullName) {
    let words = fullName.split(" - ");
    words = words[0].split(" ");
    return words[0].charAt(0) + words[words.length - 1].charAt(0);
  }
  return "";
};

export const formatValuepayroll = (value) => {
  return new Intl.NumberFormat().format(Math.round(value));
};

export const getDurationDate = (startDate, endDate) => {
  let duration = undefined;
  if (startDate && startDate !== null && startDate !== "null" && endDate && endDate !== null && endDate !== "") {
    duration = moment.duration(endDate.diff(startDate));
  }
  return duration;
};

export const getUnique = (arr, comp) => {
  if (arr) {
    const unique = arr
      .map((e) => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }
};

export const scaleScreen = () => {
  let content = `width=device-width,initial-scale=0.45`;
  if (document.body.clientWidth <= 768) {
    document.querySelector('meta[name="viewport"]').setAttribute("content", content);
  }
};

export const getMessages = (message) => {
  let messages = [];
  if (message && Array.isArray(message)) {
    message.forEach((msg) => messages.push(msg));
  } else {
    messages.push(message);
  }
  return messages;
};

export const checkShowWithLastTimesheet = (
  date,
  lastTimesheetDate,
  timeline,
  formatDate = DATE_FORMAT_FULL,
  dataTimeNow = moment(new Date()).format(DATE_FORMAT_V2_FULL),
  formatLastTimesheetDate = DATE_FORMAT_SHORT
) => {
  if (date && lastTimesheetDate) {
    // const currentDate = moment("2022-08-26 10:01:00", DATE_FORMAT_FULL);
    const currentDate = moment(dataTimeNow, DATE_FORMAT_V2_FULL);
    const dateCompare = moment(lastTimesheetDate, formatLastTimesheetDate).add({
      days: 1,
      hours: timeline ? timeline : 0,
    });
    if (currentDate.isAfter(dateCompare)) {
      return moment(date, formatDate).isAfter(moment(lastTimesheetDate, formatLastTimesheetDate).endOf("day"));
    } else {
      return moment(date, formatDate).isAfter(moment(lastTimesheetDate, formatLastTimesheetDate).subtract(1, "months"));
    }
  } else {
    return true;
  }
};

export const disableWeekendCommon = (
  date,
  lastTimesheetDate,
  timeline,
  formatDate,
  dataTimeNow,
  formatLastTimesheetDate
) => {
  return !checkShowWithLastTimesheet(
    date,
    lastTimesheetDate,
    timeline,
    formatDate,
    dataTimeNow,
    formatLastTimesheetDate
  );
};

export const getInfoStaff = (staff) => {
  if (staff) {
    const fullName = staff?.name;
    let departmentNameEn = "";
    if (staff.department_name) {
      departmentNameEn = staff.department_name?.name ?? "";
    } else {
      departmentNameEn = staff?.departmentName ?? "";
    }

    if (fullName && departmentNameEn) {
      return `${fullName} - ${departmentNameEn}`;
    } else if (fullName && !departmentNameEn) {
      return fullName;
    } else return "";
  }
  return "";
};

export const getStatus = (key) => {
  if (key) {
    return STATUS_FLEXIBLE.find((item) => item.key === key);
  } else {
    return "";
  }
};

export const getCheckInOrOut = (date, formatDate) => {
  if (date) {
    if (!formatDate) {
      return moment(date, DATE_FORMAT_V2_FULL).format("HH:mm");
    } else {
      return moment(date, formatDate).format("HH:mm");
    }
  }
  return "-";
};

export const beforeUploadFile = (file) => {
  const exc = ["pdf", "txt", "csv", "mp4", "jpg", "jpeg", "docx", "xlsx", "png", "pptx"];
  if (
    exc.indexOf(
      file.name
        .split(".")
        .pop()
        ?.toLowerCase()
    ) === -1
  ) {
    return { isValid: false, message: "Attach file is wrong format" };
  }
  // check size file > 5MB
  if (file.size > 5242880) {
    return { isValid: false, message: "Maximum allowed file size is 5.0 MB" };
  }
  return { isValid: true };
};

export const getData = (data) => {
  if (data) {
    return data;
  }
  return "-";
};

export const formatDateToString = (date, formatTo = DATE_FORMAT_V2, formatFrom = DATE_FORMAT_FULL) => {
  if (!date) return "";
  return moment(date, formatFrom).format(formatTo);
};

export const toFixedNumber = (number, digits = 2) => {
  if (!number) return 0;
  return Number(parseFloat(number).toFixed(digits));
};

export const getHoursWorkingDay = (workingTime, block = BLOCK) => {
  if (!workingTime) return [];
  const workingTimeParse = parseFloat(workingTime) ?? 0;
  if (!workingTimeParse) {
    return [];
  }
  const workingTimeParseMinutes = workingTimeParse * 60;
  const result = {};

  for (let i = 0; i <= workingTimeParseMinutes; i += block) {
    if (i === 0) {
      continue;
    }
    const hourMinute = getHourMinutesFromMinutes(i);
    if (!result[hourMinute.hour]) {
      result[hourMinute.hour] = [];
    }

    result[hourMinute.hour] = result[hourMinute.hour].concat(hourMinute.minute);

    if (workingTimeParseMinutes - i < block && workingTimeParseMinutes !== i) {
      const hourMinute = getHourMinutesFromMinutes(workingTimeParseMinutes);
      if (!result[hourMinute.hour]) {
        result[hourMinute.hour] = [];
      }

      result[hourMinute.hour] = result[hourMinute.hour].concat(hourMinute.minute);
    }
  }
  if (isEmpty(result)) return [];
  return Object.keys(result).map((hour) => {
    return {
      key: uuid(),
      value: parseFloat(hour) ?? 0,
      label: `${hour} hour(s)`,
      children: result?.[hour]?.map((minute) => ({
        key: minute,
        value: parseFloat(minute) ?? 0,
        label: `${minute} minute(s)`,
      })),
    };
  });
};

export const getHourMinutesFromMinutes = (minutes) => {
  if (!minutes) {
    return {
      hour: 0,
      minute: 0,
    };
  }
  return {
    hour: Math.floor(minutes / 60),
    minute: minutes % 60,
  };
};

export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
};
